import React from "react";

import Card from "../Card";

import { experienceTitle, experienceData } from "../../data/experienceData";

import { sortByImportance } from "../../utils";

const Experience = ({ activeSection }) => {
  const experiences = sortByImportance(experienceData);

  return (
    <section id="experience">
      <h3 className={activeSection === "experience" ? "active" : ""}>
        {experienceTitle}
      </h3>
      <ul>
        {experiences.map((el) => (
          <Card
            key={el.key}
            date={el.date}
            title={el.title}
            establishment={el.establishment}
            info={el.info}
            image={el.image}
            links={el.links}
          />
        ))}
      </ul>
    </section>
  );
};

export default Experience;
